import React from 'react';

import ApproversTable from '../user/ApproversTable';

import Button from 'CommonComponents/Button';
import FormTextRow from 'CommonComponents/FormTextRow';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function ExpenseFundApprovalViewModal(props) {
    return (
        <div id={props.modalId} ref={props.modalRef} tabIndex="-1" aria-hidden="true" className="hidden modal__box">
            <div className="modal__container">
                <div className="modal__inner-container">
                    <ModalHeader title={$t('Expanse Fund Approval Details')} close={props.closeHandler}></ModalHeader>
                    <div className="tw-rounded-b">
                        {Object.keys(props.efa).length > 0 && (
                            <div className="modal__form-container">
                                <FormTextRow label={$t('Department') + ':'} text={props.efa.expense.department.name}></FormTextRow>

                                <FormTextRow
                                    label={$t('Costcenter') + ':'}
                                    text={props.efa.expense.costcenter ? props.efa.expense.costcenter.name : '-'}
                                ></FormTextRow>

                                <FormTextRow label={$t('Expense') + ':'} text={props.efa.expense.name}></FormTextRow>

                                <FormTextRow label={$t('Expense reference number') + ':'} text={props.efa.expense.reference_number}></FormTextRow>

                                <FormTextRow label={$t('Expense total') + ':'} text={props.efa.expense.cashflowObject.total}></FormTextRow>

                                <FormTextRow label={$t('Difference') + ':'} text={props.efa.amount_data.totalDifference}></FormTextRow>

                                <FormTextRow label={$t('Status') + ':'} text={props.efa.canceled_at ? 'Canceled' : props.efa.status_label}></FormTextRow>

                                <div className="table__card">
                                    <ApproversTable
                                        approvers={props.efa.approvers || []}
                                        status={props.efa.status_label}
                                        displayApprovalStatuses={props.displayApprovalStatuses}
                                    />
                                </div>
                                <div className="modal__footer">
                                    <Button variant="secondary" onClick={props.closeHandler}>
                                        {$t('Close')}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
